import { Toast, ToastBody, ToastContainer, ToastHeader } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';

const ToastU = () => {
    const { t } = useTranslation();
    const { toast, setToast } = useAuth();

    let textColor = '';
    switch(toast.variant) {
        case 'primary':
        case 'dark':
        case 'danger':
        case 'success':
        case 'secondary':
            textColor = 'text-white';
            break;
        case 'info':
        case 'warning':
            textColor = 'text-dark';
            break;
        default: textColor = 'text-white';
    }
    
    return (
        <ToastContainer className='p-3' position='top-end' style={{ zIndex: 998, position: 'fixed'}}>
            {toast && <Toast bg={toast?.variant} onClose={() => setToast({...toast, show: false})} show={toast?.show} delay={3000} autohide>
                <ToastHeader>
                    <span className="rounded-1 bg-dark p-2 me-2" />
                    <strong className="me-auto">{toast?.title}</strong>
                    <small>{t('NOW')}</small>
                </ToastHeader>
                <ToastBody className={`${textColor}`}>
                    {toast?.content}
                </ToastBody>
            </Toast>}
        </ToastContainer>
    );
}

export default ToastU;